import { lazy } from 'react';

const CustomerEdit = lazy(() => import('./CustomerEdit'));

export default CustomerEdit;
